import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { decrypt, encrypt } from "../utils/cryptoUtils";
import { fundhistry } from "../redux/InitiatepayoutSlice";
import { makeAuthenticatedRequest, Report } from "../utils/api";
import { AxiosError } from "../components/sessionexpiry";
import { payoutbenehistry } from "../redux/InitiatepayoutSlice";
import {
  CalendarIcon,
  CheckCircleIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  Download,
  XCircleIcon,
  X,
} from "lucide-react";
import { ToastContainer, toast } from "react-toastify";
import "./Dashboard.css";
// Add these imports at the top of your wallet.js file
import {
  ClockIcon,
  ArrowDownIcon,
  ArrowsRightLeftIcon,
  LockClosedIcon,
  ArrowPathIcon,
  MinusCircleIcon,
  PauseIcon,
  QuestionMarkCircleIcon,
  ArrowDownTrayIcon,
  MagnifyingGlassIcon,
  DocumentArrowDownIcon,
  EllipsisHorizontalIcon,
} from "@heroicons/react/20/solid"; // or 24/solid depending on version

// If you're not using Heroicons v2, you might need to install it first:
// npm install @heroicons/react

const Wallet = () => {
  const [form, setForm] = useState({
    name: "",
    number: "",
    email: "",
    location: "",
    number2: "",
    ifsc: "",
    bank: "",
    amount: "",
    remarks: "",
    mode: "IMPS",
  });

  const allFilled = Object.values(form).every((v) => v.trim() !== "");

  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [status, setStatus] = useState("all");

  const [showModal, setShowModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false); // New state for report modal
  const [reportDate, setReportDate] = useState({
    startDate: new Date().toISOString().slice(0, 10),
    endDate: new Date().toISOString().slice(0, 10),
  });
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);

  const limit = 5;
  const offset = (currentPage - 1) * limit;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const merchantData = useSelector((state) => state.Initiatepayout.fundlist);

  //console.log("Merchant Data in Wallet:", merchantData);

  const users = JSON.parse(sessionStorage.getItem("users"));
  const user_id = users?.userdatils?.kycs_step ? users.userdatils.user_id : "0";
  //console.log("User ID:", users);
  const fetchData = async () => {
    try {
      const whereClause = [
        {
          column: "mid",
          operator: "=",
          value: user_id,
        },
      ];

      if (status != "all") {
        whereClause.push({
          column: "type",
          operator: "=",
          value: status,
        });
      }
      //console.log("Where Clause:", user_id);
      const requestData = JSON.stringify({
        Dname: "payout",
        Tname: "fund_history",
        Cname: [
          "id",
          "type",
          "mid",
          "amount",
          "reference",
          "open_balance",
          "close_balance",
          "status",
          "remarks",
          // "created_at",
          "CONVERT_TZ(created_at, @@session.time_zone, '+05:30') as created_at",
        ],
        Where: whereClause,
        Order: { id: "desc" },
        Search: searchTerm,
        Limit: `${limit}`,
        Offset: `${offset}`,
      });

      //console.log("Request Data:", requestData);
      const encrypted = encrypt(requestData);
      //console.log(encrypted);
      const data = await makeAuthenticatedRequest("POST", "/fetch", {
        encrypted,
      });
      //console.log(data);
      const decryptdata = decrypt(data);
      //console.log(decryptdata);
      const fixedString = decryptdata.replace(/\\"/g, '"');
      const jsonArray = JSON.parse(fixedString);
      setTotalCount(jsonArray[0].TotalCount);
      dispatch(fundhistry(jsonArray));
      //console.log("Merchant Data after Decryption:", fundhistry);
      //console.log(reponse);
    } catch (err) {
      setError(
        "Failed to fetch data: " + (err.response?.data?.message || err.message),
      );
    }
  };

  // const merchantBene = useSelector(
  //   (state) => state.Initiatepayout.payoutbenelist
  // );

  // const fetchBene = async () => {
  //   try {
  //     const requestData = JSON.stringify({
  //       Dname: "payout",
  //       Tname: "payout_merch_bene",
  //       Cname: [
  //         "mid",
  //         "beneName",
  //         "beneMobileNo",
  //         "bankname",
  //         "beneAccNum",
  //         "beneIfscCode",
  //         "status",
  //         "CONVERT_TZ(created_at, @@session.time_zone, '+05:30') as created_at",
  //       ],
  //       Where: [
  //         {
  //           column: "mid",
  //           operator: "=",
  //           value: user_id,
  //         },
  //       ],
  //       Order: { id: "desc" },
  //       Limit: "10",
  //       Offset: "0",
  //     });

  //     const encrypted = encrypt(requestData);
  //     //console.log("encrypted", encrypted);
  //     const data = await makeAuthenticatedRequest(
  //       "POST",
  //       "/fetch",
  //       {
  //         encrypted,
  //       },
  //       navigate
  //     );
  //     //console.log("data", data);
  //     const decryptdata = decrypt(data);
  //     //console.log("decryptdata", decryptdata);
  //     const fixedString = decryptdata.replace(/\\"/g, '"');
  //     const jsonArray = JSON.parse(fixedString);
  //     //setTotalCount(jsonArray[0].TotalCount);
  //     dispatch(payoutbenehistry(jsonArray));
  //     //console.log("merchantBene", jsonArray);
  //   } catch (err) {
  //     setError(
  //       "Failed to fetch data: " + (err.response?.data?.message || err.message)
  //     );
  //   }
  // };

  useEffect(() => {
    fetchData();
    //fetchBene();
  }, [searchTerm, currentPage, status]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when new search happens
  };

  const goToNextPage = () => setCurrentPage((prev) => prev + 1);
  const goToPrevPage = () =>
    setCurrentPage((prev) => (prev > 1 ? prev - 1 : 1));

  const totalPages = Math.ceil(totalCount / limit); // Calculate total pages

  const lastpayouts =
    merchantData && merchantData.length > 0 ? merchantData : [];

  //////Balance

  const Todaypayoutsdetailes = useSelector((state) => state.Dashboard.today);
  const fund_history = useSelector((state) => state.Dashboard.fundloads);

  const [profileData, setProfileData] = useState({
    payout_balance: "0.00",
    virtual_account_no: "000000000000",
  });
  const [responseData, setResponseData] = useState(null);
  // useEffect(() => {
  //   const payout_balance = async () => {
  //     try {
  //       const requestData = JSON.stringify({
  //         Dname: "payout",
  //         Tname: "merchants m",
  //         Cname: [
  //           "payout_balance",
  //           "status",
  //           "virtual_account_no",
  //           "virtual_account_IFSC",
  //           "day_limit",
  //           "transac_limit",
  //           "CONVERT_TZ(created_at, @@session.time_zone, '+05:30') as created_at",
  //         ],
  //         Where: [
  //           {
  //             column: "m.mid",
  //             operator: "=",
  //             value: user_id,
  //           },
  //         ],
  //         Limit: "10",
  //         Offset: "0",
  //       });

  //       const encrypted = encrypt(requestData);
  //       const data = await makeAuthenticatedRequest(
  //         "POST",
  //         "/fetch",
  //         { encrypted },
  //         navigate
  //       );

  //       const decryptdata = decrypt(data);
  //       const fixedString = decryptdata.replace(/\\"/g, '"');
  //       const jsonArray = JSON.parse(fixedString);

  //       if (jsonArray.length > 1) {
  //         setProfileData({
  //           payout_balance: jsonArray[1].payout_balance || "0.00",
  //           status: jsonArray[1].status || "0",
  //           virtual_account_no:
  //             jsonArray[1].virtual_account_no || "000000000000",
  //           virtual_account_IFSC:
  //             jsonArray[1].virtual_account_IFSC || "000000000000",
  //           day_limit: jsonArray[1].day_limit || "0.00",
  //           transac_limit: jsonArray[1].transac_limit || "0.00",
  //           created_at: jsonArray[1].created_at || "000000000000",
  //         });
  //       }
  //       //setResponseData(jsonArray);
  //       //console.log("Profile Data:", jsonArray[1]);
  //     } catch (err) {
  //       setError(err.message);
  //       AxiosError(navigate, err);
  //     }
  //   };
  //   //payout_balance();
  // }, []);

  // const FundDownload = async () => {
  //   try {
  //     const Date = reportDate.startDate; // Use the date from the input
  //     const data = await Report(
  //       "GET",
  //       `/loads/by-date/download?date=${Date}&mid=${user_id}&type=excel`,
  //       navigate
  //     );

  //     toast.success("Report generated successfully!");
  //     //showReportModal(false);
  //     //const blob = new Blob([data], { type: "text/csv" });
  //     //const url = window.URL.createObjectURL(blob);
  //     //const a = document.createElement("a");
  //   } catch (err) {
  //     setError(err.message);
  //     AxiosError(navigate, err);
  //   }
  // };

  const FundDownload = async () => {
    try {
      const startDate = reportDate.startDate;
      const endDate = reportDate.endDate;
      const url = `/loads/by-date/download?fromDate=${startDate}&toDate=${endDate}&mid=${user_id}&type=csv`;

      const response = await Report("GET", url, navigate);

      const blob = response.data;

      const text = await blob.text();
      console.log("CSV Content Preview:", text.slice(0, 200)); // Just a preview

      // 🔍 Try to extract filename from headers (if backend sends it)
      const contentDisposition = response.headers["content-disposition"];
      let filename = `Inwardsfund_report_${startDate}_To_${endDate}.csv`;

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match?.[1]) {
          filename = match[1];
        }
      }

      // 🔻 Start file download
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      toast.success("Report downloaded successfully!");
    } catch (err) {
      console.error("Download Error:", err);
      setError(err.message);
      AxiosError(navigate, err);
    }
  };

  return (
    <main className="main-content animate-fade-in-up mesh-bg min-h-screen relative overflow-hidden overflow-y-hidden w-[1195px]">
      {/* Decorative Floating Color Orbs */}
      <div className="color-orb-1 top-10 left-10 pointer-events-none" />
      <div className="color-orb-2 bottom-20 right-10 pointer-events-none" />

      {/* Header */}
      <div className="mb-6 flex flex-col md:flex-row md:items-center md:justify-between bg-gradient-to-r from-indigo-900 via-indigo-950 to-slate-950 rounded-3xl px-8 py-6 shadow-xl relative overflow-hidden border border-slate-900 animate-fade-in-up">
        {/* Ambient light leaks inside header */}
        <div className="absolute -top-24 -left-24 w-48 h-48 bg-indigo-500/10 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute -bottom-24 -right-24 w-24 h-48 bg-purple-500/10 rounded-full blur-3xl pointer-events-none" />

        <div className="relative z-10">
          <h2 className="text-3xl font-extrabold text-white tracking-tight flex items-center gap-2">
            <span>Inward Funds</span>
            <span className="text-xs px-2.5 py-0.5 bg-indigo-500/25 border border-indigo-500/35 text-indigo-300 rounded-full font-bold uppercase tracking-wider">Funds</span>
          </h2>
          <p className="text-indigo-200/80 text-sm mt-1.5 font-medium">
            Monitor, audit, and generate accounting reports for inbound collections.
          </p>
        </div>
        <nav className="mt-4 md:mt-0 relative z-10">
          <ol className="flex items-center space-x-2 text-xs font-semibold">
            <li>
              <Link to="/dashboard" className="flex items-center gap-1.5 py-2 px-3 bg-white/5 hover:bg-white/10 rounded-xl text-indigo-200 hover:text-white transition duration-200 border border-white/5">
                <span className="material-icons text-sm">dashboard</span>
                <span>Console</span>
              </Link>
            </li>
            <li className="text-indigo-400">/</li>
            <li className="text-indigo-300/60 font-normal">Inward Funds</li>
          </ol>
        </nav>
      </div>

      {/* Table */}
      <div className="w-full max-w-full overflow-hidden animate-fade-in-up animate-delay-100">
        <div className="glass-panel rounded-3xl border border-slate-100 shadow-sm overflow-hidden">
          {/* Header Section */}
          <div className="px-6 py-5">
            {/* Search, Status, and Controls Section */}
            <div className="flex flex-col lg:flex-row lg:justify-between items-center gap-4">
              {/* Left Side: Search, Status & Generate Report */}
              <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
                {/* Search Box */}
                <div className="relative w-full sm:w-64">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <MagnifyingGlassIcon className="h-4 w-4 text-slate-400" />
                  </div>
                  <input
                    type="text"
                    placeholder="Search Transaction ID/Ref"
                    className="premium-input bg-slate-50/30 rounded-xl pl-10 pr-3 py-2 text-sm w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 font-semibold text-slate-700 placeholder-slate-400 border-slate-200"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                </div>

                {/* Status Dropdown */}
                <div className="relative w-full sm:w-48">
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <ChevronDownIcon className="h-4 w-4 text-slate-400" />
                  </div>
                  <select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    className="premium-input bg-slate-50/30 rounded-xl px-3 py-2 text-sm w-full appearance-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 font-bold text-slate-600 border-slate-200"
                  >
                    <option value="all">All Transactions</option>
                    <option value="1">Fund Loads</option>
                    <option value="4">Refunds</option>
                    <option value="3">Liens</option>
                    <option value="5">Deductions</option>
                  </select>
                </div>

                {/* <button
                  onClick={() => setShowReportModal(true)}
                  className="flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-violet-600 text-white px-5 py-2.5 rounded-xl text-sm font-semibold shadow-md shadow-indigo-100 hover:shadow-indigo-200 hover:shadow-lg transform hover:-translate-y-0.5 transition duration-150 whitespace-nowrap relative overflow-hidden group"
                >
                  <span className="absolute inset-0 bg-gradient-to-r from-indigo-500 to-violet-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  <DocumentArrowDownIcon className="w-4 h-4 relative z-10 transition-transform group-hover:scale-110" />
                  <span className="relative z-10">Generate Audit Report</span>
                </button> */}
              </div>

              {/* Right Side: Pagination */}
              <div className="w-full lg:w-auto flex justify-center lg:justify-end">
                <div className="inline-flex rounded-xl shadow-sm border border-slate-200 bg-white overflow-hidden p-0.5">
                  <button
                    className="inline-flex items-center px-3 py-1.5 text-xs font-bold text-slate-500 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition rounded-lg"
                    onClick={goToPrevPage}
                    disabled={currentPage === 1}
                  >
                    <ChevronLeftIcon className="h-4 w-4 mr-0.5" />
                    Prev
                  </button>

                  {/* Always show first page */}
                  <button
                    className={`inline-flex items-center px-3.5 py-1.5 text-xs font-extrabold rounded-lg transition ${
                      currentPage === 1
                        ? "bg-indigo-600 text-white shadow-md shadow-indigo-100"
                        : "text-slate-600 hover:bg-slate-50"
                    }`}
                    onClick={() => setCurrentPage(1)}
                  >
                    1
                  </button>

                  {/* Ellipsis */}
                  {currentPage > 3 && (
                    <span className="inline-flex items-center px-2 py-1.5 text-slate-400">
                      <EllipsisHorizontalIcon className="h-4 w-4" />
                    </span>
                  )}

                  {/* Middle Pages */}
                  {[...Array(totalPages)]
                    .map((_, i) => i + 1)
                    .filter(
                      (page) =>
                        page > 1 &&
                        page < totalPages &&
                        Math.abs(page - currentPage) <= 1,
                    )
                    .map((page) => (
                      <button
                        key={page}
                        className={`inline-flex items-center px-3.5 py-1.5 text-xs font-extrabold rounded-lg transition ${
                          currentPage === page
                            ? "bg-indigo-600 text-white shadow-md shadow-indigo-100"
                            : "text-slate-600 hover:bg-slate-50"
                        }`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    ))}

                  {/* Ellipsis */}
                  {currentPage < totalPages - 2 && (
                    <span className="inline-flex items-center px-2 py-1.5 text-slate-400">
                      <EllipsisHorizontalIcon className="h-4 w-4" />
                    </span>
                  )}

                  {/* Last Page */}
                  {totalPages > 1 && (
                    <button
                      className={`inline-flex items-center px-3.5 py-1.5 text-xs font-extrabold rounded-lg transition ${
                        currentPage === totalPages
                          ? "bg-indigo-600 text-white shadow-md shadow-indigo-100"
                          : "text-slate-600 hover:bg-slate-50"
                      }`}
                      onClick={() => setCurrentPage(totalPages)}
                    >
                      {totalPages}
                    </button>
                  )}

                  <button
                    className="inline-flex items-center px-3 py-1.5 text-xs font-bold text-slate-500 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition rounded-lg"
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                    <ChevronRightIcon className="h-4 w-4 ml-0.5" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="p-5 border-t border-slate-100/60 bg-white/40">
            <div className="overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm">
              <div className="max-w-full overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr
                      className="text-slate-400 text-xs font-bold border-b border-slate-100 whitespace-nowrap text-center bg-slate-50/50"
                    >
                      <th className="px-5 py-4 sm:px-6 uppercase tracking-wider">SI.No</th>
                      <th className="px-5 py-4 sm:px-6 uppercase tracking-wider">Created On</th>
                      <th className="px-5 py-4 sm:px-6 uppercase tracking-wider">Fund type</th>
                      <th className="px-5 py-4 sm:px-6 uppercase tracking-wider">Amount</th>
                      <th className="p-4 uppercase tracking-wider">Reference No</th>
                      <th className="px-5 py-4 sm:px-6 uppercase tracking-wider">Status</th>
                      <th className="px-5 py-4 sm:px-6 uppercase tracking-wider">Remark</th>
                      <th className="px-5 py-4 sm:px-6 uppercase tracking-wider">Open Balance</th>
                      <th className="px-5 py-4 sm:px-6 uppercase tracking-wider">Close Balance</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100 whitespace-nowrap text-center">
                    {merchantData.slice(1).length > 0 ? (
                      merchantData.slice(1).map((payout, index) => (
                        <tr
                          key={payout.payout_id}
                          className="hover:bg-slate-50/60 transition duration-150 border-b border-slate-100"
                        >
                          <td className="px-5 py-4 text-slate-500 font-semibold text-sm">
                            {index + 1 + (currentPage - 1) * limit}
                          </td>
                          <td className="px-5 py-4 text-slate-500 text-xs font-semibold">
                            {new Date(payout.created_at).toLocaleString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              },
                            )}
                          </td>

                          <td className="px-3 py-4 whitespace-nowrap">
                            <span
                              className={`inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-bold border
                                ${
                                  payout.type === "1"
                                    ? "bg-indigo-50 text-indigo-700 border-indigo-100" // fund load
                                    : payout.type === "2"
                                      ? "bg-blue-50 text-blue-700 border-blue-100" // Internal Fund
                                      : payout.type === "4"
                                        ? "bg-emerald-50 text-emerald-700 border-emerald-100" // Refund
                                        : payout.type === "0"
                                          ? "bg-slate-50 text-slate-700 border-slate-200" // Pending
                                          : payout.type === "3"
                                            ? "bg-amber-50 text-amber-700 border-amber-100" // Lien
                                            : payout.type === "5"
                                              ? "bg-rose-50 text-rose-700 border-rose-100" // Deduction
                                              : payout.type === "6"
                                                ? "bg-slate-100 text-slate-800 border-slate-200" // On Hold
                                                : "bg-slate-50 text-slate-600 border-slate-200" // Unknown
                                }`}
                            >
                              {payout.type === "0" ? (
                                <ClockIcon className="w-3.5 h-3.5 mr-1" />
                              ) : payout.type === "1" ? (
                                <ArrowDownIcon className="w-3.5 h-3.5 mr-1" />
                              ) : payout.type === "2" ? (
                                <ArrowsRightLeftIcon className="w-3.5 h-3.5 mr-1" />
                              ) : payout.type === "3" ? (
                                <LockClosedIcon className="w-3.5 h-3.5 mr-1" />
                              ) : payout.type === "4" ? (
                                <ArrowPathIcon className="w-3.5 h-3.5 mr-1" />
                              ) : payout.type === "5" ? (
                                <MinusCircleIcon className="w-3.5 h-3.5 mr-1" />
                              ) : payout.type === "6" ? (
                                <PauseIcon className="w-3.5 h-3.5 mr-1" />
                              ) : (
                                <QuestionMarkCircleIcon className="w-3.5 h-3.5 mr-1" />
                              )}
                              {payout.type === "0"
                                ? "Pending"
                                : payout.type === "1"
                                  ? "Fund Load"
                                  : payout.type === "2"
                                    ? "Internal Fund"
                                    : payout.type === "3"
                                      ? "Lien"
                                      : payout.type === "4"
                                        ? "Refund"
                                        : payout.type === "5"
                                          ? "Deduction"
                                          : payout.type === "6"
                                            ? "On Hold"
                                            : "Unknown"}
                            </span>
                          </td>

                          <td className="px-5 py-4 text-slate-800 font-bold text-sm">
                            ₹ {payout.amount}
                          </td>

                          <td className="px-5 py-4 font-mono text-xs text-slate-500 font-bold">
                            {payout.reference || "-"}
                          </td>

                          <td className="px-3 py-4 whitespace-nowrap">
                            <span
                              className={`inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-bold border
    ${
      payout.status === "1"
        ? "bg-emerald-50 text-emerald-700 border-emerald-100"
        : payout.status === "0"
          ? "bg-amber-50 text-amber-700 border-amber-100"
          : payout.status === "2"
            ? "bg-red-50 text-red-700 border-red-100"
            : payout.status === "3"
              ? "bg-blue-50 text-blue-700 border-blue-100"
              : "bg-slate-100 text-slate-700 border-slate-200"
    }`}
                            >
                              <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
                                payout.status === "1"
                                  ? "bg-emerald-500"
                                  : payout.status === "0"
                                    ? "bg-amber-500 animate-pulse"
                                    : payout.status === "2"
                                      ? "bg-red-500"
                                      : payout.status === "3"
                                        ? "bg-blue-500 animate-pulse"
                                        : "bg-slate-500"
                              }`} />
                              {payout.status === "1"
                                ? "Success"
                                : payout.status === "0"
                                  ? "Pending"
                                  : payout.status === "2"
                                    ? "Rejected"
                                    : payout.status === "3"
                                      ? "Initialization"
                                      : "Unknown"}
                            </span>
                          </td>

                          <td className="px-5 py-4 text-slate-500 text-xs font-semibold max-w-xs truncate">
                            {payout.remarks || "-"}
                          </td>

                          <td className="px-5 py-4 text-slate-600 font-bold text-sm">
                            ₹ {payout.open_balance || "-"}
                          </td>

                          <td className="px-5 py-4 text-slate-600 font-bold text-sm">
                            ₹ {payout.close_balance || "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="9"
                          className="text-center py-16 text-slate-400 font-medium"
                        >
                          <span className="material-symbols-outlined text-4xl block text-slate-300 mb-1">receipt_long</span>
                          No Inward funds history found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {showReportModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-md transition-all duration-300 animate-fade-in-up">
              <div className="glass-modal w-full max-w-md rounded-3xl shadow-2xl p-8 relative mx-4 border border-slate-100 transform scale-100">
                <button
                  className="absolute top-5 right-5 p-2 rounded-xl text-slate-400 hover:text-slate-600 hover:bg-slate-50 transition-colors"
                  onClick={() => setShowReportModal(false)}
                >
                  <X className="w-5 h-5" />
                </button>

                <div className="space-y-1 mb-6">
                  <h2 className="text-2xl font-bold text-slate-800 tracking-tight">
                    Generate Report
                  </h2>
                  <p className="text-xs text-slate-500 font-medium">
                    Select a date range to export inward fund records.
                  </p>
                </div>

                <div className="space-y-5">
                  {/* From Date */}
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      From Date
                    </label>
                    <div className="relative">
                      <input
                        type="date"
                        className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all text-slate-700 font-semibold premium-input bg-slate-50/50"
                        value={reportDate.startDate}
                        onChange={(e) =>
                          setReportDate({
                            ...reportDate,
                            startDate: e.target.value,
                          })
                        }
                        max={new Date().toISOString().slice(0, 10)}
                      />
                    </div>
                  </div>

                  {/* To Date */}
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      To Date
                    </label>
                    <div className="relative">
                      <input
                        type="date"
                        className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all text-slate-700 font-semibold premium-input bg-slate-50/50"
                        value={reportDate.endDate}
                        onChange={(e) =>
                          setReportDate({
                            ...reportDate,
                            endDate: e.target.value,
                          })
                        }
                        max={new Date().toISOString().slice(0, 10)}
                      />
                    </div>
                  </div>

                  {/* Download Button */}
                  <button
                    onClick={FundDownload}
                    disabled={isGeneratingReport}
                    className={`mt-6 w-full py-3 rounded-xl font-bold flex items-center justify-center space-x-2 transition-all text-white shadow-lg ${
                      isGeneratingReport
                        ? "bg-indigo-400 cursor-not-allowed"
                        : "bg-indigo-600 hover:bg-indigo-700 shadow-indigo-100 hover:shadow-indigo-200 transform hover:-translate-y-0.5"
                    }`}
                  >
                    {isGeneratingReport ? (
                      <>
                        <ArrowPathIcon className="w-5 h-5 animate-spin" />
                        <span>Generating Report...</span>
                      </>
                    ) : (
                      <>
                        <ArrowDownTrayIcon className="w-5 h-5" />
                        <span>Download CSV Report</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          <ToastContainer position="top-right" autoClose={3000} />
        </div>
      </div>
    </main>
  );
};

export default Wallet;
